import { Phone, X } from "@phosphor-icons/react";
import { useEffect } from "react";
import { createPortal } from "react-dom";

interface OrderCancelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  phone: string;
  phoneHref: string;
}

export function OrderCancelDialog({ isOpen, onClose, phone, phoneHref }: OrderCancelDialogProps) {
  useEffect(() => {
    if (!isOpen || typeof document === "undefined") {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen || typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-stone-950/58 px-4 py-6 backdrop-blur-[3px]"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="w-full max-w-[28rem] rounded-[2rem] border border-white/70 bg-[rgba(249,244,236,0.98)] p-5 text-stone-950 shadow-[0_34px_78px_-38px_rgba(12,35,36,0.62)]"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="cancel-order-title"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-[0.72rem] uppercase tracking-[0.18em] text-rose-700">Отмена заказа</p>
            <h2 id="cancel-order-title" className="mt-2 text-[1.5rem] font-semibold tracking-[-0.05em]">
              Для отмены заказа наберите по номеру
            </h2>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-stone-900/10 bg-white text-stone-700 transition duration-300 active:scale-[0.98]"
            aria-label="Закрыть окно отмены заказа"
          >
            <X size={18} />
          </button>
        </div>

        <div className="mt-5 rounded-[1.7rem] border border-stone-900/8 bg-white px-4 py-4">
          <p className="text-[0.72rem] uppercase tracking-[0.16em] text-stone-500">Номер телефона</p>
          <p className="mt-2 text-[1.6rem] font-semibold tracking-[-0.06em] text-stone-950">{phone}</p>
          <p className="mt-2 text-sm leading-6 text-stone-600">
            С компьютера можно просто переписать номер, а с телефона нажать кнопку ниже.
          </p>
        </div>

        <p className="mt-4 text-sm leading-7 text-stone-600">
          Владелец точки подтвердит отмену и снимет заказ вручную после звонка.
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2">
          <a
            href={phoneHref}
            className="inline-flex items-center justify-center gap-2 rounded-[1.4rem] bg-rose-600 px-4 py-3 text-sm font-medium text-white transition duration-300 active:translate-y-px active:scale-[0.98]"
          >
            <Phone size={16} />
            Позвонить
          </a>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-[1.4rem] border border-stone-900/10 bg-white px-4 py-3 text-sm font-medium text-stone-700 transition duration-300 active:translate-y-px active:scale-[0.98]"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
